import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isObject from 'lodash/isObject';

// CORE COMPONENTS
import Tooltip from 'core/tools/Tooltip';
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from './tableHeaderTooltip.module.scss';

// MAIN COMPONENT
const TableHeaderTooltip = ({ children, tooltip, codes }) => {
  const tipMemo = useMemo(() => {
    let tipObject = isObject(tooltip) ? tooltip : undefined;
    if (codes)
      tipObject = Object.assign(tipObject || {}, {
        header: tooltip,
        keys: Object.keys(codes)
          .map(codeKey => {
            const code = codes[codeKey];
            if ((!code.icon && !code.code) || !code.label) return;
            return {
              className: code.className,
              icon: code.icon,
              label: code.code,
              description: code.label
            };
          })
          .filter(key => !!key)
      });
    return !tooltip && !tipObject ? undefined : (
      <>
        {tipObject?.header && <h3 className={styles.header}>{tipObject.header}</h3>}
        {!!tipObject?.keys?.length && (
          <table className={styles.table}>
            <tbody>
              {tipObject.keys.map(({ className, icon, label, description } = {}, i) => (
                <tr key={i}>
                  <td className={styles.label}>
                    {label && <span className={clsx(styles.label, className)}>{label}</span>}
                    {icon && <Sprite className={clsx(styles.sprite, className)} size="md" use={icon} />}
                  </td>
                  <td className={styles.description}>{description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {!!tipObject ? tipObject.body : tooltip}
      </>
    );
  }, [tooltip, codes]);

  return !tipMemo ? (
    children
  ) : (
    <Tooltip placement="bottom" tip={tipMemo}>
      {children}
    </Tooltip>
  );
};

// EXPORT
export default TableHeaderTooltip;
